import Placeholder, {PlaceholderProps} from './Placeholder';
import {PropsWithChildren} from 'react';

interface PlaceholderTextProps {
    isFetching: boolean;
    placeholderProps: PlaceholderProps;
}

const PlaceholderText = ({
    isFetching,
    placeholderProps,
    children,
}: PropsWithChildren<PlaceholderTextProps>): JSX.Element => {
    if (isFetching) {
        return <Placeholder {...placeholderProps} />;
    }
    return <>{children}</>;
};

export default PlaceholderText;
